// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1ZTqZ","content":"GlobalSearch_content__8icuB"};